module.exports = ".top-box-program-status-link {\r\n  cursor: pointer;\r\n}\r\n\r\n  .top-box-program-status-link:hover {\r\n    color: #4b80e0 !important;\r\n  }\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/member-billing-info/registered-members/registered-members.component.css
// module id = ./src/app/shared/components/member-billing-info/registered-members/registered-members.component.css
// module chunks = main